import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-doc-article-top-user-groups',
  templateUrl: './doc-article-top-user-groups.component.html',
  styleUrls: ['./doc-article-top-user-groups.component.css']
})
export class DocArticleTopUserGroupsComponent implements OnInit {
    docArticleKeynoTop;

    public itemsListTopUserGroups: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.docArticleKeynoTop = this.stateService.getStateParams()['docarticle_keyno_top'];
    }

    private async loadTopUserGroups() {
        if (!!this.docArticleKeynoTop) {
            this.itemsListTopUserGroups = await this.datatask.Post(1382, { docarticle_keyno_top: this.docArticleKeynoTop });
        }
    }

    private async init() {
        this.loadTopUserGroups();
    }

    ngOnInit() {
        this.init();
    }
}
